import IframeResizer from "iframe-resizer-react";
import { useEffect, useState } from "react";

export type IframeWrapperAttr = {
  className?: string;
};

export type IframeProps = {
  src: string;
  title?: string;
  className?: string;
  allowFullScreen?: boolean;
  addWrapper?: boolean;
  wrapperAttr?: IframeWrapperAttr;
};

export default function Iframe({
  src,
  title = "#NoTapis",
  className,
  allowFullScreen = false,
  addWrapper = false,
  wrapperAttr = {},
}: IframeProps) {
  const [isMobile, setIsMobile] = useState<boolean>(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Mobile breakpoint
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const iframe = (
    <IframeResizer
      src={src}
      checkOrigin={false}
      title={title}
      allowFullScreen={allowFullScreen}
      className={className}
      heightcalculationmethod={isMobile ? "bodyScroll" : "max"}
      style={{
        width: "1px",
        minWidth: isMobile ? "95%" : "100%",
        border: "none",
        minHeight: isMobile ? "1040px" : "642px",
      }}
    />
  );

  return addWrapper ? (
    <div className={wrapperAttr.className}>{iframe}</div>
  ) : (
    iframe
  );
}
